// Dependencies
import React from 'react';

import PropTypes from 'prop-types';

// Utils
import { Heading } from '@nerdwallet/currency';
import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

// Components
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';

// Local components
import ImageSizes from '../../config/images/imageSizes';
import ElementImpressionInteraction from '../../containers/element-impression-interaction';

const Cta = ({ children, iconName, subtitle, title, trackingId }) => {
  const impressionId = `mortgages-${trackingId}`;

  return (
    <div className="cta">
      <img
        className="cta-img"
        {...ImageSizes.largeIcon.measures}
        src={iconUri(iconName)}
        alt=""
      />
      {title ? (
        <div className="cta-title">
          <Heading level="5">{title}</Heading>
        </div>
      ) : null}
      {subtitle ? <div className="cta-subtitle">{subtitle}</div> : null}
      <div className="cta-controls">
        <ElementImpression id={impressionId} elementName={trackingId}>
          <ElementImpressionInteraction
            id={impressionId}
            elementName={trackingId}
            type="CLICK"
          >
            {children}
          </ElementImpressionInteraction>
        </ElementImpression>
      </div>
    </div>
  );
};

Cta.propTypes = {
  children: PropTypes.node.isRequired,
  iconName: PropTypes.string.isRequired,
  trackingId: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

Cta.defaultProps = {
  subtitle: null,
  title: null,
};

export default Cta;
